import { AnnualReviewCycle } from './AnnualReview';

export enum USER_ROLES {
  MENTOR = 'MENTOR',
  HR = 'HR',
  MENTEE = 'MENTEE',
}

export interface MenteesProps {
  id: string;
  email: string;
  mentorEmail: string;
  name: string;
  tier: string;
  designation: string;
  userRoles: [
    {
      id: string;
      userId: string;
      role: {
        id: string;
        name: USER_ROLES.HR | USER_ROLES.MENTOR;
      };
    },
  ];
  mentor: {
    id: string;
    name: string;
    email: string;
    designation: string;
    tier: number | string;
  };
  objectiveCount: number;
  lastAccessedDate: string | null;
}

export interface EmployeeData extends MenteesProps {
  cycleId: string;
  cycleName: string;
  annualData: AnnualReviewCycle[];
  quarterData?: AllReviewsProps[];
}

export interface objectiveFeedback {
  id: string;
  objectiveId: string;
  quarterId: string;
  cycleId: string;
  mentorId: string;
  menteeId: string;
  menteeComment: null | string;
  mentorComment: null | string;
  menteeCommentStatus: null | string;
  mentorCommentStatus: null | string;
}

export interface menteeObjectiveProps {
  id: string;
  description: string;
  startDate: string;
  endDate: string;
  expectedOutcome: string;
  status: string;
  mentorId: string;
  menteeId: string;
  objectiveCategory: string;
  objectiveComments: objectiveFeedback[] | null;
  creationDate: string;
  reason: string;
  updatedBy: string;
  updatedAt: string;
}

export interface AllReviewsProps {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  year: string | number;
  status: number;
  cycleId: string;
  menteeDeadline: string;
  mentorDeadline: string;
  cycle: null | string;
  objectiveComments: objectiveFeedback[] | null;
  progress: number;
}

export interface ReviewAssignedMenteesProps {
  name: string;
  designation: string;
  tier: string;
  mentorName: string;
  noOfObjectives: string;
  mentorStatus: string;
  menteeStatus: string;
}

export type MyObjectiveActions = 'delete' | 'edit' | 'view' | 'active';
export type NotificationTypes = 'success' | 'info' | 'warning' | 'error';

export interface commonRes {
  error: boolean;
}

// api requests and responses -----------------------------
export interface createObjReq {
  description: string;
  startDate?: string;
  endDate: string;
  expectedOutcome: string;
  status: string;
  mentorId?: string;
  menteeId?: string;
  quarterId?: string;
  cycleId?: string;
  objectiveCategory: string;
  reason: string;
}

export interface updateObjReq {
  description: string;
  startDate: string;
  endDate: string;
  expectedOutcome: string;
  status: string;
  mentorId: string;
  menteeId: string;
  objectiveCategory: string;
  objectiveComments: objectiveFeedback[] | null;
}

export interface createQuarterProps {
  Name: string;
  StartDate: string;
  EndDate: string;
  MenteeDeadline: string;
  MentorDeadline: string;
}

export interface updateQuarterProps {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  year: number;
  status: number;
  cycleId: string;
  cycle: null | string;
  menteeDeadline: string;
  mentorDeadline: string;
}

// quarterly review user info
export interface quarterlyUsers {
  user: {
    id: string;
    email: string;
    name: string;
    mentorEmail: string;
    tier: number;
    designation: string;
    userRoles: [];
    mentor: {
      id: string;
      name: string;
      email: string;
      designation: string;
      tier: number;
    };
    objectiveCount: 0;
  };
  mentorStatus: string;
  menteeStatus: string;
  menteeSubmissionDate: string | null;
  mentorSubmissionDate: string | null;
}

export interface updateFeedbacksPayload {
  quarterlyObjectivesList: menteeObjectiveProps[];
  commentStatus: string;
  quarterId: string;
}

export interface auditTrailData {
  id: string;
  operationType: string;
  changedAt: string;
  changedBy: string;
  originalData: string;
  newData: string;
  reason: string;
  objectiveId: string;
  changedByUser: {
    id: string;
    name: string;
    email: string;
    mentorEmail: string;
    tier: number;
    designation: string;
    isActive: boolean;
    userRoles: [] | null;
    mentor: string;
    objectiveCount: number;
  };
}

export interface ErrorResponseType {
  message: string;
  details: string;
  status: number;
}

export interface ObjectiveReport {
  menteeName: string;
  mentorName: string;
  objectiveType: string;
  description: string;
  status: string;
  expectedOutcome: string;
  startDate: string;
  endDate: string;
}

export interface Mentor {
  id: string;
  name: string;
  email: string;
  designation: string;
  tier: number;
}

export interface User {
  id: string;
  email: string;
  name: string;
  mentorEmail: string;
  tier: number;
  designation: string;
  isActive: boolean;
  userRoles: [];
  mentor: Mentor;
  objectiveCount: number;
}

export interface QuarterlyUserStatus {
  user: User;
  mentorStatus: string;
  menteeStatus: string;
}

// Mentor feedback notes (Sprint 2)
export interface FeedbackNote {
  id: string;
  mentorId: string;
  menteeId: string;
  objectiveId: string | null;
  quarterId: string | null;
  noteText: string;
  createdDate: string;
}

export interface CreateFeedbackNoteReq {
  menteeId: string;
  objectiveId?: string | null;
  quarterId?: string | null;
  noteText: string;
}
